import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../../helpers/form/FormHelper'
import ErrorMessage from '../../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../../UI/form/MyButton'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../helpers/form/FormData'
import DeliveryTypesSelectMain from '../../../../../form/fields/DeliveryTypesSelectMain'
import DeliveryTtnField from './fields/DeliveryTtnField'
import { responseError } from '../../../../../../helpers/response/ResponseHelper'
import { useDispatch } from 'react-redux'
import { addSupplyBillDeliveries, editSupplyBillDelivery } from '../../../../../../store/supplyBillSlice'
import { addDeliveryBySupplyBillAPI, editDeliveryByIdAPI } from '../../../../../../api/delivery/deliveryAPI'
import DeliveryDateDeadlineField from './fields/DeliveryDateDeadlineField'
import { getDateOnly } from '../../../../../../helpers/date/dateHelper'
import DeliveryStatusSelect from './fields/DeliveryStatusSelect'

const SupplyBillDeliveryForm = ({ supplyBillId, billDeliveryBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(billDeliveryBd ? billDeliveryBd : {}) // Дані з форми
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = setDataForBd()
        console.log('dataForBd', dataForBd)

        setError('')
        setLoading(true)

        if (dataForBd.id) {
            edit(dataForBd)
        } else {
            add(dataForBd)
        }
    }

    const add = (dataForBd) => {
        addDeliveryBySupplyBillAPI(dataForBd).then(data => {
            if (data) {
                dispatch(addSupplyBillDeliveries(data))
            }
            // if (data && data.supplyBills) {
            //     dispatch(setSupplyOrderBills(data.supplyBills))
            // }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }
    
    const edit = (dataForBd) => {
        editDeliveryByIdAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editSupplyBillDelivery(data))
            }
            // if (data && data.supplyBills) {
            //     dispatch(setSupplyOrderBills(data.supplyBills))
            // }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const setDataForBd = () => {
        let dataForBd = {
            supplyBillId,
            deliveryTypeId: data.deliveryTypeId,
            ttn: data.ttn,
            dateDeadline: data.dateDeadline,
            status: data.status,
            // dateDeadline: data.dateDeadline ? getDateOnly(data.dateDeadline) : null,
        }

        if (data.id) {
            dataForBd = {
                ...dataForBd,
                id: data.id
            }
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('deliveryTypeId', 'supplyBillDelivery') ?
				<DeliveryTypesSelectMain
					required={formDataProductRequiredField('deliveryTypeId', 'supplyBillDelivery')}
					setValidate={e => updateValidate(setValid, 'deliveryTypeId', e)}
					setValueForm={e => setValueForm(setData, 'deliveryTypeId', e)}
					forciblyValue={data && data.deliveryTypeId ? data.deliveryTypeId : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('status', 'supplyBillDelivery') ?
				<DeliveryStatusSelect
					required={formDataProductRequiredField('status', 'supplyBillDelivery')}
					setValidate={e => updateValidate(setValid, 'status', e)}
					setValueForm={e => setValueForm(setData, 'status', e)}
					forciblyValue={data && data.status ? data.status : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('ttn', 'supplyBillDelivery') ?
				<DeliveryTtnField
					required={formDataProductRequiredField('ttn', 'supplyBillDelivery')}
					setValidate={e => updateValidate(setValid, 'ttn', e)}
					setValueForm={e => setValueForm(setData, 'ttn', e)}
					forciblyValue={data && data.ttn ? data.ttn : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('dateDeadline', 'supplyBillDelivery') ?
				<DeliveryDateDeadlineField
					required={formDataProductRequiredField('dateDeadline', 'supplyBillDelivery')}
					setValidate={e => updateValidate(setValid, 'dateDeadline', e)}
					setValueForm={e => setValueForm(setData, 'dateDeadline', e)}
					forciblyValue={data && data.dateDeadline ? data.dateDeadline : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default SupplyBillDeliveryForm